import { render, staticRenderFns } from "./TheMapCluster.vue?vue&type=template&id=3f37bd9d&functional=true&"
var script = {}
import style0 from "./TheMapCluster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports